import React, { useState, useEffect, useRef } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { setVendorName } from '../../redux/actions/vendorAction'
import HttpService from '../../services/httpService'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import TableHead from '@material-ui/core/TableHead';
import { DownloadOutlined, FileFilled, RobotFilled, RollbackOutlined } from '@ant-design/icons';
import { Button, Input, Menu } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { ROLENAME } from '../../utils/index';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box } from '@material-ui/core';



const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    // const { vendorDetail } = useSelector(state => state.vendor)

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    table: {
        minWidth: 500,
    },
    textField: {
        width: "150px"
    },
    paperClass: {
        height: '100%'
    },
    returnButton: { backgroundColor: 'white', color: '#EF3F32', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#EF3F32", color: 'white' } },
    approveButton: { backgroundColor: 'white', color: '#157525', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#355025", color: 'white' } },
    UploadDocsbuttons: { borderRadius: 50, backgroundColor: 'white', color: '#2c2e3e', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#2c2e3e", color: 'white' } },
    deleteIcon: { cursor: "pointer", verticalAlign: 'middle', marginLeft: 10, color: "red", fontSize: 20 },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
    },
    body: {
        fontSize: 14,
        backgroundColor: "#fff",
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const MaterialsCheckListApprovals = (props) => {
    const routerHistory = useHistory();
    let j = 1;
    const classes = useStyles2();
    useEffect(() => {
        getMaterialsChecklistApprovals()
    }, [])

    const { userDetails } = useSelector(state => state.user)
    const [matChecklistApprovalLeads, setMatChecklistApprovalLeads] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, matChecklistApprovalLeads.length - page * rowsPerPage)
    const [leadDetails, setLeadDetails] = useState({})
    const [loading, setLoading] = useState(false);
    const [headers, setHeaders] = useState([]);




    const getMaterialsChecklistApprovals = async () => {
        setLoading(true); // Start the loader
        try {
            const response = await HttpService.getEleChecklistApprovals(userDetails.selectedExpCenter);
            setMatChecklistApprovalLeads(response.data);
        } catch (error) {
            props.setSnackInfo(error);
        } finally {
            setLoading(false); // Stop the loader
        }
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const navigateToCheckList = (e, data) => {
        e.preventDefault();
        routerHistory.push(`/materials-checklist/${data._id}`);
    };



    return (
        <div >

            {/* heading */}
            <h1 style={{ textAlign: 'center' }}>Electrical-Domestic Checklist Approvals </h1>
            {loading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}>
                    <Oval
                        height={80}
                        width={80}
                        color="#4fa94d"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            )}


            {!loading && (<TableContainer component={Paper}>

                <Table className={classes.table} size="small" aria-label="custom pagination table">

                    <TableHead>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 20, 50, { label: 'All', value: matChecklistApprovalLeads?.length }]}
                                colSpan={14}
                                count={matChecklistApprovalLeads.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { 'aria-label': 'rows per page' },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                        <TableRow>
                            <StyledTableCell style={{ textAlign: 'center' }}>Sl.No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Lead No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Project No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Client Name</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Designer</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>ADM</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Current Stage</StyledTableCell>
                            <StyledTableCell colSpan={3} style={{ textAlign: 'center' }}>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {!matChecklistApprovalLeads || matChecklistApprovalLeads.length === 0 ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <p>No approvals pending</p>
                            </div>
                        ) : (
                            matChecklistApprovalLeads.map((data, i) => (
                                <StyledTableRow key={i}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {data.lead_no ? (
                                            <Link to={`/project-logs/${data._id}`} target="_blank" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>
                                                {data.lead_no}
                                            </Link>
                                        ) : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {data.erpProjectNo ? (
                                            <Link to={`/project-logs/${data?._id}`} target="_blank" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>
                                                {data.erpProjectNo}
                                            </Link>
                                        ) : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {data.customerId ? data.customerId.name : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>
                                        {data.designUser ? data.designUser.name : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>
                                        {data.designAssistantManager ? data.designAssistantManager.name : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>
                                        {data.currentStage ? data.currentStage : 'NA'}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>
                                        <Button
                                            className={classes.approveButton}
                                            variant="contained"
                                            onClick={(e) => navigateToCheckList(e, data)}
                                        >
                                            View Details
                                        </Button>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        )}


                    </TableBody>
                </Table>
            </TableContainer>)}


        </div>
    )
}



export default connect(null, { setLoading, setSnackInfo })(MaterialsCheckListApprovals)